import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import "./admin.css";
import apiClient from '../../acciones/apiClient';

import { NavBar } from "../../componentes/navbar/index";
import iconoEditar from "../../img/iconoEditar.png";
import iconoEliminar from "../../img/iconoEliminar.png";

import { getUsuarios, updateUsuarioRango, getComentariosTotal } from '../../acciones';

import { getSliders, deleteSlider } from '../../acciones/index';

import { getProyectos } from '../../acciones/index';
// import { addPopularSeries } from '../../acciones/index';
import * as XLSX from 'xlsx';


export const Administrador = () => {

    const [perfil, setPerfil] = useState(null);
    const [activeTab, setActiveTab] = useState('Proyectos');
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [sliderToDelete, setSliderToDelete] = useState(null);

    const [sliders, setSliders] = useState([]);
    const [title, setTitle] = useState('');
    const [info, setInfo] = useState('');
    const [image, setImage] = useState(null);


    const dispatch = useDispatch();
    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState('Todos');
    const [sortOrder, setSortOrder] = useState('A - Z');
    const [limit, setLimit] = useState(10);
    const usuarios = useSelector(state => state.usuariosTotal);

    const [imgPrincipal, setImgPrincipal] = useState(null); // Estado para almacenar la imagen


    // Estado para Series Populares
    const [visibility, setVisibility] = useState('dia'); // Valor por defecto: 'dia'
    const [selectedProjectId, setSelectedProjectId] = useState(null); // Proyecto seleccionado
    const [position, setPosition] = useState(''); // Posición del proyecto
    const [duration, setDuration] = useState(''); // Duración en horas

    const [searchUserTerm, setSearchUserTerm] = useState('');
    const [filteredUsers, setFilteredUsers] = useState([]);
    const comentarios = useSelector((state) => state.comentarios);
    const [nombre_usuario, setNombreUsuario] = useState([]);
    const [paginaActual, setPaginaActual] = useState(1);
    const totalPages = useSelector((state) => state.totalPages);
    const [currentPage, setCurrentPage] = useState(1);
        useEffect(() => {
        const filtered = usuarios.filter((usuario) =>
            usuario.nombre_usuario.toLowerCase().includes(searchUserTerm.toLowerCase())
        );
        setFilteredUsers(filtered);
    }, [searchUserTerm, usuarios]);

    const deleteProyecto = (proyectoId) => async (dispatch) => {
        try {
            await apiClient.delete(`/proyectos/${proyectoId}`);
            dispatch({ type: 'DELETE_PROYECTO', payload: proyectoId });
        } catch (error) {
            console.log(error);
        }
    };

    const deleteUsuario = (usuarioId) => async (dispatch) => {
        try {
            await apiClient.delete(`/usuarios/${usuarioId}`);
            dispatch({ type: 'DELETE_USUARIO', payload: usuarioId });
        } catch (error) {
            console.log(error);
        }
    };

    const deleteComentario = (comentarioId) => async (dispatch) => {
        try {
            await apiClient.delete(`/comentarios/proyectos/${comentarioId}`);
            dispatch({ type: 'DELETE_COMENTARIOS_PROYECTOS', payload: comentarioId });
        } catch (error) {
            console.log(error);
        }
    };

    const handleDeleteClick = (id) => {
        if (window.confirm("¿Estás seguro de que quieres eliminar este proyecto?")) {
            dispatch(deleteProyecto(id));
        }
    };

    const handleDeleteClickUsuario = (id) => {
        if (window.confirm("¿Estás seguro de que quieres eliminar este usuario?")) {
            dispatch(deleteUsuario(id));
        }
    };

    const handleDeleteComment = (id) => {
        if (window.confirm("¿Estás seguro de que quieres eliminar este comentario?")) {
            dispatch(deleteComentario(id));
        }
    };

    const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };

    const handleDeleteConfirm = () => {
        // Implement delete functionality here
        setIsDeleteModalOpen(false);
    };


    // Manejar la selección de la imagen
    const handleImgPrincipalChange = async (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            try {
                console.log("Archivo seleccionado:", selectedFile); // Log del archivo seleccionado
                const compressedImage = await convertImageToWebpUsingCanvas(selectedFile, 0.9);

                setImgPrincipal(compressedImage); // Actualizar el estado con la imagen comprimida
                console.log("Imagen procesada:", compressedImage); // Log de la imagen procesada
            } catch (error) {
                console.error('Error al procesar la imagen:', error); // Log detallado del error
            }
        }
    };


    // Manejar el envío del formulario
    const handleSubmitImgPrincipal = async (e) => {
        e.preventDefault();

        console.log("Subida de imagen iniciada"); // Agregar log inicial

        if (!imgPrincipal) {
            alert('Por favor, selecciona una imagen antes de subir.');
            return;
        }

        const formData = new FormData();
        formData.append('imgPrinci', imgPrincipal); // Añadir la imagen al formulario

        try {
            console.log("Enviando imagen al backend"); // Log antes de la solicitud
            const response = await apiClient.post('/imgPrincipal/subir', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            alert('Imagen principal subida con éxito.');
            console.log('Respuesta del servidor:', response.data); // Log de la respuesta del servidor
            setImgPrincipal(null); // Limpiar el estado después del envío
        } catch (error) {
            console.error('Error al subir la imagen principal:', error.response?.data || error.message); // Log detallado del error
            alert('Error al subir la imagen principal.');
        }
    };




    const [titulo, setTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');





    useEffect(() => {
        dispatch(getUsuarios());
    }, [dispatch]);

    useEffect(() => {
        dispatch(getComentariosTotal());
    }, [dispatch]);



    const confirmDelete = () => {
        setSliders(sliders.filter((_, i) => i !== sliderToDelete));
        setShowModal(false);
        setSliderToDelete(null);
    };

    const cancelDelete = () => {
        setShowModal(false);
        setSliderToDelete(null);
    };

    const handleRangoChange = (id, event) => {
        const nuevoRango = event.target.value;
        dispatch(updateUsuarioRango(id, nuevoRango));
    };


    // ------------------Administrador---------------------

    const [formData, setFormData] = useState({
        title: '',
        description: '',
        cover: null,
        visibility: 'publico',
        seriesType: 'manhwa',
        isAdult: false,
        author: '',
        year: '',
        altName: '',
        studio: '',
        demographics: '',
        genres: []
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleGenreChange = (e) => {
        const { value, checked } = e.target;

        setFormData(prev => {
            if (checked) {
                // Si el checkbox está marcado, añade el género al array
                return { ...prev, genres: [...prev.genres, value] };
            } else {
                // Si el checkbox se desmarca, quita el género del array
                return { ...prev, genres: prev.genres.filter(genre => genre !== value) };
            }
        });
    };


    const handleSubmitAñaPro = async (e) => {
        e.preventDefault();

        if (!perfil || !perfil.user_id) {
            alert("El ID del usuario no está disponible. Por favor, inicia sesión.");
            return;
        }

        if (!formData.cover) {
            alert("La portada es requerida. Por favor, selecciona una imagen.");
            return;
        }

        const data = new FormData();
        data.append("userId", perfil.user_id); // ID del usuario conectado
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("visibility", formData.visibility);
        data.append("seriesType", formData.seriesType);
        data.append("isAdult", formData.isAdult);
        data.append("author", formData.author);
        data.append("year", formData.year);
        data.append("altName", formData.altName);
        data.append("studio", formData.studio);
        data.append("demographics", formData.demographics);
        data.append("cover", formData.cover);

        // Añade los géneros al FormData
        formData.genres.forEach(genre => {
            data.append("genders", genre);
        });

        try {
            const response = await apiClient.post('/proyectos', data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            alert("Proyecto subido con éxito");
            console.log('Proyecto creado con éxito', response.data);
        } catch (error) {
            console.error('Error al crear el proyecto:', error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        setPerfil({ user_id: 2 }); // Simula un usuario con ID 1
    }, []);




    // ---------------------------Sliders------------------------

    const slider = useSelector(state => state.sliders);

    console.log('Sliders:', slider); // Ver qué sliders están llegando al frontend

    useEffect(() => {
        dispatch(getSliders());
    }, [dispatch]);



    const handleDeleteSlider = (id) => {
        if (window.confirm('¿Estás seguro de que quieres eliminar este slider?')) {
            dispatch(deleteSlider(id));
        }
    };

    // ----------------------proyectos-----------------------------

    const proyectos = useSelector((state) => state.proyectos);

    useEffect(() => {
        dispatch(getProyectos(currentPage,limit));
    }, [dispatch, currentPage]);

    const cambiarPagina = (pagina) => {
        dispatch(getProyectos(pagina));
    };

    const filteredProyectos = Array.isArray(proyectos)
        ? proyectos.filter(proyecto =>
            proyecto.titulo?.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : [];

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // Función para manejar el cambio en el selector de tipo de serie
    const handleFilterTypeChange = (e) => {
        setFilterType(e.target.value);
    };


    // Filtrar proyectos
    const filteredProjects = Array.isArray(proyectos)
        ? proyectos
            .filter((proyecto) => {
                const titleMatch = proyecto.titulo?.toLowerCase().includes(searchTerm.toLowerCase());
                const typeMatch =
                    filterType.toLowerCase() === 'todos' ||
                    proyecto.tipo_serie?.toLowerCase() === filterType.toLowerCase();
                return titleMatch && typeMatch;
            })
            .sort((a, b) => {
                if (sortOrder === 'A - Z') return a.titulo.localeCompare(b.titulo);
                if (sortOrder === 'Z - A') return b.titulo.localeCompare(a.titulo);
                if (sortOrder === 'Mas Vistos') return b.vistas - a.vistas;
                if (sortOrder === 'Ultimos Proyectos') return new Date(b.fecha_creacion) - new Date(a.fecha_creacion);
                if (sortOrder === 'Ultimos Capitulos') return new Date(b.fecha_capitulo) - new Date(a.fecha_capitulo);
                return 0;
            })
            .slice(0, limit)
        : [];




    // ----------------------------seriesPopulares-------------------------


    // Función para manejar el envío del formulario de Series Populares
    const handleSubmitSeriePopu = async (e) => {
        e.preventDefault();

        // Validaciones
        if (!visibility) {
            alert('Por favor, selecciona la visibilidad (día, semana o todo).');
            return;
        }

        if (!selectedProjectId) {
            alert('Por favor, selecciona un proyecto de la lista.');
            return;
        }

        const positionNumber = parseInt(position);
        if (isNaN(positionNumber) || positionNumber < 1 || positionNumber > 5) {
            alert('La posición debe estar entre 1 y 5.');
            return;
        }

        const durationNumber = parseInt(duration);
        if (isNaN(durationNumber) || durationNumber <= 0) {
            alert('La duración debe ser un número positivo (en horas).');
            return;
        }

        // Datos a enviar al backend
        const data = {
            visibility: visibility,
            proyectoId: selectedProjectId,
            position: positionNumber,
            duration: durationNumber,
        };

        try {
            // Enviar datos al backend
            const response = await apiClient.post('/popular-series', data, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            // Mostrar mensaje de éxito
            alert('Serie popular subida con éxito');
            console.log('Serie popular creada:', response.data);

            // Reiniciar el formulario
            setVisibility('dia');
            setSelectedProjectId(null);
            setPosition('');
            setDuration('');
        } catch (error) {
            console.error('Error al crear la serie popular:', error.response ? error.response.data : error.message);
            alert('Error al crear la serie popular. Intenta nuevamente.');
        }
    };




    // Modificación en handleImageChangeSlider para Slider
    const handleImageChangeSlider = async (e) => {
        const selectedFile = e.target.files[0];

        if (selectedFile) {
            try {
                // Convierte la imagen seleccionada a .webp usando canvas
                const compressedImage = await convertImageToWebpUsingCanvas(selectedFile, 0.9);
                setImage(compressedImage); // Asigna la imagen comprimida y convertida al estado
                console.log('Imagen de slider comprimida y convertida:', compressedImage);
            } catch (error) {
                console.error('Error al convertir y comprimir la imagen del slider:', error);
            }
        }
    };


    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];

        if (selectedFile) {
            try {
                const compressedImage = await convertImageToWebpUsingCanvas(selectedFile, 0.9);
                setImage(compressedImage); // Actualizar el estado de 'image'
                setFormData((prevState) => ({
                    ...prevState,
                    cover: compressedImage
                }));
                console.log('Imagen comprimida y convertida:', compressedImage);
            } catch (error) {
                console.error('Error al convertir y comprimir la imagen:', error);
            }
        }
    };


    // Modificación en handleSubmitNoti para enviar la imagen comprimida
    const handleSubmitNoti = async (e) => {
        e.preventDefault();
        if (!image) {
            alert('Por favor, selecciona una imagen antes de enviar.');
            return;
        }

        const formData = new FormData();
        formData.append('imgNotifi', image);
        formData.append('titulo', titulo);
        formData.append('descripcion', descripcion);

        try {
            await apiClient.post('/notificaciones', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            alert("Notificación subida con éxito");
        } catch (error) {
            console.error('Error al crear la notificación:', error);
        }
    };

    const convertImageToWebpUsingCanvas = (file, quality = 0.9) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                const img = new Image();
                img.src = reader.result;

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    // Establece el tamaño del canvas en función del tamaño de la imagen
                    canvas.width = img.width;
                    canvas.height = img.height;

                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    // Convierte la imagen en formato .webp y ajusta la calidad
                    canvas.toBlob((blob) => {
                        resolve(blob);
                    }, 'image/webp', quality);
                };

                img.onerror = (error) => reject(error);
            };

            reader.onerror = (error) => reject(error);
        });
    };


    const handleDownloadExcel = () => {
        const data = proyectos.map((proyecto) => {
            const usuario = usuarios.find(u => u.user_id === proyecto.usuario_id);
            return {
                'Proyecto': proyecto.titulo,
                'Vistas': proyecto.vistas,
                'Nombre del Autor': proyecto.autor,
                'Nombre del Usuario': usuario ? usuario.nombre_usuario : 'Desconocido',
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Proyectos');

        XLSX.writeFile(workbook, 'Todos_Los_Proyectos.xlsx');
    };


    // Manejar el envío del formulario para crear un slider
    const handleSubmitSlider = async (e) => {
        e.preventDefault();

        if (!title || !info || !image || !selectedProjectId) {
            alert('Por favor completa todos los campos.');
            return;
        }

        const formData = new FormData();
        formData.append('title', title);
        formData.append('info', info);
        formData.append('image', image);
        formData.append('projectId', selectedProjectId); // Enviar el ID del proyecto seleccionado

        try {
            await apiClient.post('/slider', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            alert('Slider subido con éxito');
            setImage(null);
            setTitle('');
            setInfo('');
            setSelectedProjectId(null); // Resetear el ID del proyecto seleccionado
        } catch (error) {
            console.error('Error al subir el slider:', error);
        }
    };



    return (
        <div className="todoAdministrador">
            <NavBar />

            <div className="containerAdmin">
                <div className="sidebarAdmin">
                    <ul>
                        <li className={activeTab === 'Proyectos' ? 'active' : ''} onClick={() => setActiveTab('Proyectos')}> Proyectos </li>
                        <li className={activeTab === 'Añadir Proyecto' ? 'active' : ''} onClick={() => setActiveTab('Añadir Proyecto')}>Añadir Proyecto</li>
                        <li className={activeTab === 'Slider' ? 'active' : ''} onClick={() => setActiveTab('Slider')}>Slider</li>
                        <li className={activeTab === 'Series Populares' ? 'active' : ''} onClick={() => setActiveTab('Series Populares')}>Series Populares</li>
                        <li className={activeTab === 'Notificaciones' ? 'active' : ''} onClick={() => setActiveTab('Notificaciones')}>Notificaciones</li>
                        <li className={activeTab === 'Usuarios' ? 'active' : ''} onClick={() => setActiveTab('Usuarios')}>Usuarios</li>
                        <li className={activeTab === 'Imagen Principal' ? 'active' : ''} onClick={() => setActiveTab('Imagen Principal')}>Imagen Principal</li>
                        <li className={activeTab === 'Comentarios' ? 'active' : ''} onClick={() => setActiveTab('Comentarios')}>Comentarios</li>
                    </ul>
                </div>
                <div className="contentAdmin">
                    {activeTab === 'Proyectos' && (
                        <>



                            <div class="groupAdmin">
                                <svg viewBox="0 0 24 24" aria-hidden="true" class="iconAdmin">
                                    <g>
                                        <path
                                            d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"
                                        ></path>
                                    </g>
                                </svg>
                                <input
                                    className="inputAdmin"
                                    type="search"
                                    placeholder="Buscar..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                />
                            </div>


                            <br />


                            <div className="filtersAdmin">
                                <select onChange={handleFilterTypeChange}>
                                    <option value="todos">Todos</option>
                                    <option value="manhwa">Manhwa</option>
                                    <option value="novela">Novela</option>
                                </select>
                                <select onChange={(e) => setSortOrder(e.target.value)}>
                                    <option value="">Ordenar por</option>
                                    <option value="A - Z">A - Z</option>
                                    <option value="Z - A">Z - A</option>
                                    <option value="Mas Vistos">Mas Vistos</option>
                                    <option value="Ultimos Proyectos">Ultimos Proyectos</option>
                                    <option value="Ultimos Capitulos">Ultimos Capitulos</option>
                                </select>
                                <select onChange={(e) => setLimit(parseInt(e.target.value))}>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                </select>
                                <select>
                                    <option>Grupos</option>
                                </select>
                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Título</th>
                                        <th>Fecha de creación</th>
                                        <th>Vistas</th>
                                        <th>Estado</th>
                                        <th>Tipo de Serie</th>
                                        <th>Editar</th>
                                        <th>Eliminar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredProjects.map((project) => (
                                        <tr key={project.proyecto_id}>
                                            <td>{project.proyecto_id}</td>
                                            <td>{project.titulo}</td>
                                            <td>{project.fecha_creacion}</td>
                                            <td>{project.vistas}</td>
                                            <td>{project.visibilidad}</td>
                                            <td>{project.tipo_serie}</td>
                                            <td>
                                                <a href={`/EditarProyecto/${project.proyecto_id}`}>
                                                    <img src={iconoEditar} alt="Editar" />
                                                </a>
                                            </td>
                                            <td>
                                                <img
                                                    src={iconoEliminar}
                                                    alt="Eliminar"
                                                    onClick={() => handleDeleteClick(project.proyecto_id)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="paginacion">
                                <button
                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                    className="page-button"
                                >
                                    Anterior
                                </button>

                                {Array.from({ length: totalPages }, (_, i) => i + 1).map((pagina) => (
                                    <button
                                        key={pagina}
                                        onClick={() => setCurrentPage(pagina)}
                                        className={`page-button ${currentPage === pagina ? "active" : ""}`}
                                    >
                                        {pagina}
                                    </button>
                                ))}

                                <button
                                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                    className="page-button"
                                >
                                    Siguiente
                                </button>
                            </div>


                        </>

                    )}
                    {isDeleteModalOpen && (
                        <div className="modal">
                            <div className="modal-content">
                                <span className="close" onClick={handleCloseDeleteModal}>&times;</span>
                                <div className="modal-message">
                                    <p>¿Seguro que quieres eliminar el capítulo?</p>
                                    <div className="modal-buttons">
                                        <button className="cancel-button" onClick={handleCloseDeleteModal}>Cancelar</button>
                                        <button className="accept-button" onClick={handleDeleteConfirm}>Aceptar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === 'Añadir Proyecto' &&
                        <div>




                            <form onSubmit={handleSubmitAñaPro}>
                                <div className="nuevo-proyectoAdmin2">
                                    <div className="form-containerAdmin2">
                                        <h2>Nuevo Proyecto</h2>
                                        <div className="left-sideAdmin2">
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="cover">Portada</label>
                                                <input
                                                    type="file"
                                                    name="cover"
                                                    onChange={handleFileChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="title">Título</label>
                                                <input
                                                    type="text"
                                                    id="title"
                                                    name="title"
                                                    placeholder="Agregar texto"
                                                    value={formData.title}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="description">Descripción</label>
                                                <textarea
                                                    id="description"
                                                    name="description"
                                                    placeholder="Agregar texto"
                                                    value={formData.description}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="visibility">Visibilidad</label>
                                                <select
                                                    id="visibility"
                                                    name="visibility"
                                                    value={formData.visibility}
                                                    onChange={handleChange}
                                                >
                                                    <option value="publico">Público</option>
                                                    <option value="privado">Privado</option>
                                                </select>
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="seriesType">Tipo de serie</label>
                                                <select
                                                    id="seriesType"
                                                    name="seriesType"
                                                    value={formData.seriesType}
                                                    onChange={handleChange}
                                                >   <option value="manga">Manga</option>
                                                    <option value="manhuas">Manhuas</option>
                                                    <option value="manhwa">Manhwa</option>
                                                    <option value="novela">Novela</option>
                                                </select>
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="isAdult">+18</label>
                                                <input
                                                    type="checkbox"
                                                    id="isAdult"
                                                    name="isAdult"
                                                    checked={formData.isAdult}
                                                    onChange={(e) => setFormData({ ...formData, isAdult: e.target.checked })}
                                                />
                                            </div>
                                        </div>
                                        <div className="right-sideAdmin2">
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="author">Autor</label>
                                                <input
                                                    type="text"
                                                    id="author"
                                                    name="author"
                                                    placeholder="Agregar texto"
                                                    value={formData.author}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="year">Año</label>
                                                <input
                                                    type="number"
                                                    id="year"
                                                    name="year"
                                                    placeholder="Agregar número"
                                                    value={formData.year}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="altName">Nombre alternativo</label>
                                                <input
                                                    type="text"
                                                    id="altName"
                                                    name="altName"
                                                    placeholder="Agregar texto"
                                                    value={formData.altName}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="studio">Estudio</label>
                                                <input
                                                    type="text"
                                                    id="studio"
                                                    name="studio"
                                                    placeholder="Agregar texto"
                                                    value={formData.studio}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin2">
                                                <label htmlFor="demographics">Demografía</label>
                                                <textarea
                                                    id="demographics"
                                                    name="demographics"
                                                    placeholder="Agregar texto"
                                                    value={formData.demographics}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-groupAdmin3">
                                                <label htmlFor="project">Seleccionar Género</label>
                                                <div className="radio-groupSeriesPopu">
                                                    {['+18', 'Aventura', 'Acción', 'Bestias', 'Comedia', 'Demonios', 'Deportes', 'Drama',
                                                        'Escolares', 'Fantasía', 'Harem', 'Magia', 'Misterio', 'Moderno', 'One-shot',
                                                        'Psicológicos', 'Reencarnación', 'Romance', 'Transmigración', 'Tragedia',
                                                        'Thriller', 'Smut', 'Slice of Life', 'Sobrenatural', 'Vampiros', 'Venganza']
                                                        .map(genre => (
                                                            <label key={genre}>
                                                                <input
                                                                    type="checkbox"
                                                                    value={genre}
                                                                    checked={formData.genres.includes(genre)}
                                                                    onChange={handleGenreChange}
                                                                /> {genre}
                                                            </label>
                                                        ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" className="create-project-buttonAdmin2">Crear Proyecto</button>
                                </div>
                            </form>





                        </div>
                    }
                    {activeTab === 'Slider' &&
                        <div>

                            <div>
                                <div className="slider-proyectoAdmin3">
                                    <div className="left-sideAdmin3">
                                        <form onSubmit={handleSubmitSlider}>
                                            <div className="form-groupAdmin3">
                                                <label htmlFor="image">Imagen</label>
                                                <input
                                                    type="file"
                                                    id="image"
                                                    name="image"
                                                    onChange={handleImageChangeSlider}
                                                    accept="image/*" // Asegúrate de que solo se seleccionen imágenes
                                                />
                                            </div>
                                            <div className="form-groupAdmin3">
                                                <label htmlFor="title">Título</label>
                                                <input
                                                    type="text"
                                                    id="title"
                                                    name="title"
                                                    placeholder="Agregar texto"
                                                    value={title}
                                                    onChange={(e) => setTitle(e.target.value)}
                                                    required // Validación HTML5
                                                />
                                            </div>
                                            <div className="form-groupAdmin3">
                                                <label htmlFor="info">Información</label>
                                                <textarea
                                                    id="info"
                                                    name="info"
                                                    placeholder="Agregar texto"
                                                    value={info}
                                                    onChange={(e) => setInfo(e.target.value)}
                                                    required // Validación HTML5
                                                ></textarea>
                                            </div>


                                            <div className="groupAdmin">
                                                <input
                                                    className="inputAdmin"
                                                    type="search"
                                                    placeholder="Buscar proyecto..."
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>

                                            <br />

                                            <div className="form-groupAdmin3">
                                                <label htmlFor="project">Seleccionar Proyecto</label>
                                                <div className="radio-groupSeriesPopu">
                                                    {filteredProyectos.map((proyecto) => (
                                                        <label key={proyecto.proyecto_id}>
                                                            <input
                                                                type="radio"
                                                                name="project"
                                                                value={proyecto.proyecto_id}
                                                                onChange={() => setSelectedProjectId(proyecto.proyecto_id)}
                                                            />
                                                            {proyecto.titulo}
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>


                                            <button type="submit" className="upload-buttonAdmin3">
                                                Subir Slider
                                            </button>
                                        </form>
                                    </div>
                                    {/* Mostrar sliders cargados */}
                                    <div className="right-sideAdmin3">
                                        {Array.isArray(slider) && slider.length > 0 ? (
                                            slider.map((slider) => (
                                                <div key={slider.slider_id} className="slider-itemAdmin3">
                                                    <img src={slider.imagen} alt={slider.titulo} />
                                                    <div className="slider-textAdmin3">
                                                        <h3>{slider.titulo}</h3>
                                                        <p>{slider.informacion}</p>
                                                        {slider.proyecto_id && <p>Proyecto ID: {slider.proyecto_id}</p>}
                                                    </div>
                                                    <button
                                                        className="delete-buttonAdmin3"
                                                        onClick={() => handleDeleteSlider(slider.slider_id)}
                                                    >
                                                        Eliminar
                                                    </button>
                                                </div>
                                            ))
                                        ) : (
                                            <p>No hay sliders disponibles.</p>
                                        )}
                                    </div>


                                </div>
                                {showModal && (
                                    <div className="modalAdmin3">
                                        <div className="modal-contentAdmin3">
                                            <p>¿Está seguro de borrar el slider?</p>
                                            <button onClick={confirmDelete}>Sí</button>
                                            <button onClick={cancelDelete}>No</button>
                                        </div>
                                    </div>
                                )}
                            </div>





                        </div>
                    }
                    {activeTab === 'Series Populares' && (
                        <div className="containerSeriesPopu">
                            <form onSubmit={handleSubmitSeriePopu}>
                                <select
                                    id="visibility"
                                    name="visibility"
                                    value={visibility}
                                    onChange={(e) => setVisibility(e.target.value)}
                                    required
                                >
                                    <option value="">Selecciona Visibilidad</option>
                                    <option value="dia">Día</option>
                                    <option value="semana">Semana</option>
                                    <option value="todo">Todo</option>
                                </select>

                                <br /><br />
                                <div className="groupAdmin">
                                    <input
                                        className="inputAdmin"
                                        type="search"
                                        placeholder="Buscar proyecto..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>

                                <br />

                                <div className="contentSeriesPopu">
                                    <div className="radio-groupSeriesPopu">
                                        {filteredProyectos.map((proyecto) => (
                                            <label key={proyecto.proyecto_id}>
                                                <input
                                                    type="radio"
                                                    name="option"
                                                    value={proyecto.proyecto_id}
                                                    onChange={() => setSelectedProjectId(proyecto.proyecto_id)}
                                                />
                                                {proyecto.titulo}
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                <br />

                                <div className="input-groupSeriesPopu">
                                    <div className="input-itemSeriesPopu">
                                        <label>Posición (1 a 5)</label>
                                        <input
                                            type="number"
                                            placeholder="Agregar posición"
                                            value={position}
                                            onChange={(e) => setPosition(e.target.value)}
                                            min="1"
                                            max="5"
                                        />
                                    </div>
                                    <div className="input-itemSeriesPopu">
                                        <label>Duración (horas)</label>
                                        <input
                                            type="number"
                                            placeholder="Duración en horas"
                                            value={duration}
                                            onChange={(e) => setDuration(e.target.value)}
                                            min="1"
                                        />
                                    </div>
                                </div>

                                <button type="submit" className="add-btnSeriesPopu">Agregar Serie Popular</button>
                            </form>
                        </div>

                    )}

                    {activeTab === 'Notificaciones' &&
                        <div>


                            <form onSubmit={handleSubmitNoti} className="formularioNotifi">
                                <label htmlFor="imagen">Imagen</label>
                                <input
                                    type="file"
                                    name="cover"
                                    onChange={handleFileChange}
                                />

                                <label htmlFor="titulo">Título</label>
                                <input
                                    type="text"
                                    id="titulo"
                                    placeholder="Agregar texto"
                                    value={titulo}
                                    onChange={(e) => setTitulo(e.target.value)}
                                />

                                <label htmlFor="descripcion">Descripción</label>
                                <textarea
                                    id="descripcion"
                                    placeholder="Agregar texto"
                                    value={descripcion}
                                    onChange={(e) => setDescripcion(e.target.value)}
                                />

                                <button type="submit">Enviar</button>
                            </form>


                        </div>
                    }
                    {activeTab === 'Usuarios' &&
                        <div>


                            <div className="table-containerUsua">
                                <h1>Usuarios</h1>

                                <br />
                                <div class="groupAdmin">
                                    <svg viewBox="0 0 24 24" aria-hidden="true" class="iconAdmin">
                                        <g>
                                            <path
                                                d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"
                                            ></path>
                                        </g>
                                    </svg>
                                    <input
                                        className="inputAdmin"
                                        type="search"
                                        placeholder="Buscar usuario..."
                                        value={searchUserTerm}
                                        onChange={(e) => setSearchUserTerm(e.target.value)}
                                    />

                                </div>
                                <br />


                                <button class="download-buttonUsua" onClick={handleDownloadExcel}>
                                    <div class="docs"><svg class="css-i6dzq1" stroke-linejoin="round" stroke-linecap="round" fill="none" stroke-width="2" stroke="currentColor" height="20" width="20" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line y2="13" x2="8" y1="13" x1="16"></line><line y2="17" x2="8" y1="17" x1="16"></line><polyline points="10 9 9 9 8 9"></polyline></svg> Docs</div>
                                    <div class="download">
                                        <svg class="css-i6dzq1" stroke-linejoin="round" stroke-linecap="round" fill="none" stroke-width="2" stroke="currentColor" height="24" width="24" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line y2="3" x2="12" y1="15" x1="12"></line></svg>
                                    </div>
                                </button>



                                <table>
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Correo</th>
                                            <th>Rango</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredUsers.map((usuario) => (
                                            <tr key={usuario.user_id}>
                                                <td>{usuario.nombre_usuario}</td>
                                                <td>{usuario.correo_electronico}</td>
                                                <td>
                                                    <select
                                                        value={usuario.rango}
                                                        onChange={(e) => handleRangoChange(usuario.user_id, e)}
                                                        disabled={usuario.nombre_usuario === 'Perless Scan'}
                                                    >
                                                        <option value="afiliado">Afiliado</option>
                                                        <option value="lector">Lector</option>
                                                        <option value="administrador">Administrador</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <img
                                                        src={iconoEliminar}
                                                        alt="Eliminar"
                                                        onClick={() => handleDeleteClickUsuario(usuario.user_id)}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>


                        </div>
                    }
                    {activeTab === 'Imagen Principal' && (
                        <div className="imagenPrincipalContainer">
                            <h2>Subir Imagen Principal</h2>
                            <form onSubmit={handleSubmitImgPrincipal}>
                                <div className="form-groupAdmin">
                                    <label htmlFor="imgPrincipal">Seleccionar Imagen</label>
                                    <input
                                        type="file"
                                        id="imgPrincipal"
                                        name="imgPrincipal"
                                        onChange={handleImgPrincipalChange}
                                        accept="image/*" // Solo permite imágenes
                                    />
                                </div>

                                <button type="submit" className="upload-buttonAdmin">
                                    Subir Imagen
                                </button>
                            </form>

                        </div>
                    )}

                    {activeTab === 'Comentarios' && (
                        <div>
                            <div className="table-containerUsua">
                                <h1>Administración de Comentarios</h1>

                                <br />
                                <br />

                                <table>
                                    <thead>
                                        <tr>
                                            <th>Id Comentario</th>
                                            <th>Comentario</th>
                                            <th>Usuario</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {comentarios.map((comentario) => (
                                            <tr key={comentario.comentario_id}>
                                                <td>{comentario.comentario_id}</td>
                                                <td>{comentario.comentario}</td>
                                                <td>{comentario.usuario?.nombre_usuario}</td>
                                                <td>
                                                    <img
                                                        src={iconoEliminar}
                                                        alt="Eliminar"
                                                        onClick={() => handleDeleteComment(comentario.comentario_id)}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    )}

                </div>
            </div>

        </div>
    )
}